import React, { useEffect, useState } from "react";
import Card from "components/Card/Card";
import {
  Text,
  Flex,
  Table,
  Thead,
  Tbody,
  Tfoot,
  Tr,
  Th,
  Td,
  Tooltip,
  TableContainer,
  Button,
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Textarea,
  SimpleGrid,
  useColorMode,
  useColorModeValue,
  Box,
  Input,
  Switch,
  Skeleton,

} from "@chakra-ui/react";
import ReactSelect from "react-select";
import axios from "axios";
import apiUrl from "variables/api";
import darkStyles from "variables/darkStyles"

import { toast } from "react-toastify";

function Page() {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { isOpen: isOpenNorms, onOpen: onOpenNorms, onClose: onCloseNorms } = useDisclosure();
  const [minutesText, setMinutesText] = useState("");
  const [minutesText2, setMinutesText2] = useState("");
  const [table, setTable] = useState({});
  const [selectedTable, setSelectedTable] = useState({});
  const [okres, setOkres] = useState({});
  const { colorMode } = useColorMode();
  const [options, setOptions] = useState([]);
  const [subbmiting, setSubbmiting] = useState(false);
  const [subbmitingNorm, setSubbmitingNorm] = useState(false);
  const [normy, setNormy] = useState({
    'podstawowa': '0/0',
    '1188426569925021746': '0/0', // grup specjalistycznych
    '951125741507067934': '0/0', // JRG
    '951126052871225374': '0/0', // zmian
    '1046354266354360360': '0/0', // wydzialow
    '975147351066955786': '0/0', // rzecznik
    '973342434941603931': '0/0', // szkoleniowiec
    '1084511364288102421': '0/0', // miejska
    '1084511073132105840': '0/0', // wojewodzka
    '973341575537119263': '0/0', // glowna
  });
  const [minutesNormNormal, setMinutesNormNormal] = useState(0);
  const [minutesNormManagement, setMinutesNormManagement] = useState(0);
  const [isNormActive, setIsNormActive] = useState(false);

  const handleSendMinutes = async () => {
    try {
      setSubbmiting(true);
      axios
        .post(
          apiUrl + "/data/minutes",
          { week1: minutesText, week2: minutesText2 },
          {
            headers: { "x-access-token": localStorage.getItem("token") },
          }
        )
        .then((response) => {
          if (response.data.success) {
            onClose();
            setSubbmiting(false);
            return toast.success("Pomyślnie wysłano minuty");
          } else {
            setSubbmiting(false);
            return toast.error("Napotkano błąd podczas wysyłania minut");
          }
        })
        .catch((error) => {
          console.error(error);
          setSubbmiting(false);
          toast.error("Napotkano błąd podczas połączenia z API");
        });
    } catch (error) {
      console.error("Error sending data", error);
    }
  };

  const handleSendNorm = async () => {
    try {
      setSubbmitingNorm(true);
      axios
        .put(
          apiUrl + "/data/minutes/normy",
          { minutesNormManagement, minutesNormNormal, isNormActive },
          {
            headers: { "x-access-token": localStorage.getItem("token") },
          }
        )
        .then((response) => {
          if (response.data.success) {
            onCloseNorms();
            setSubbmitingNorm(false);
            return toast.success("Pomyślnie wysłano normy");
          } else {
            setSubbmitingNorm(false);
            return toast.error("Napotkano błąd podczas wysyłania norm");
          }
        })
        .catch((error) => {
          console.error(error);
          setSubbmitingNorm(false);
          toast.error("Napotkano błąd podczas połączenia z API");
        });
    } catch (error) {
      console.error("Error sending data", error);
    }
  };

  useEffect(() => {
    axios
      .get(apiUrl + "/data/minutes", {
        headers: { "x-access-token": localStorage.getItem("token") },
      })
      .then((response) => {
        console.log(response.data);
        setTable(response.data);
        const newOptions = response.data.map((record, index) => ({
          value: record.period,
          label: `#${record.period} ${record.periodDate}`,
          index: index,
        }));
        setOptions(newOptions);
        setOkres(newOptions[0]);
      })
      .catch((error) => {
        console.error(error);
        toast.error("Napotkano błąd podczas połączenia z API");
      });
      axios
      .get(apiUrl + "/data/minutes/normy", {
        headers: { "x-access-token": localStorage.getItem("token") },
      })
      .then((response) => {
        console.log(response.data);
        setNormy(response.data);
        setMinutesNormNormal(response.data['ksf']?.normal);
        setMinutesNormManagement(response.data['ksf']?.management);
        setIsNormActive(response.data['ksf']?.enabled);
      })
      .catch((error) => {
        console.error(error);
        toast.error("Napotkano błąd podczas połączenia z API");
      });
  }, [subbmiting, subbmitingNorm]);

  const calculateReduction = (liczbaWyjazdow, roles) => {
    if (liczbaWyjazdow <= 20) return 0;
    let obnizka = Math.floor((liczbaWyjazdow - 20) / 20) * 50
    let plus = Number(getPlus(roles));
    let norma = Number(getNorma(roles));
    // console.log(plus, obnizka, norma)
    if(plus-obnizka < norma) {
       obnizka = plus - norma;
    }
    // console.log(plus, obnizka, norma)
    return obnizka;
  };

  const getNorma = (roles) => {

    const roleOrder = Object.keys(normy);
    let lastRole = 'podstawowa';
  
    for (const role of roleOrder) {
      if (roles.includes(role)) {
        lastRole = role;
      }
    }
    return normy[lastRole].split('/')[0];
  };

  const getPlus = (roles) => {
    const roleOrder = Object.keys(normy);
    let lastRole = 'podstawowa';
  
    for (const role of roleOrder) {
      if (roles.includes(role)) {
        lastRole = role;
      }
    }
  
    return normy[lastRole].split('/')[1];
  };


  return (
    <Flex flexDirection="column" pt={{ base: "120px", md: "75px" }}>
      <Card minH="125px">
        <SimpleGrid columns={{ sm: 1, md: 3, xl: 3 }} spacing="24px" mb="20px">
          <ReactSelect
          noOptionsMessage={() => "Brak dostępnych opcji"}
            options={options}
            placeholder="Wybierz..."
            styles={darkStyles()}
            value={okres}
            onChange={setOkres}
          />
          <Button onClick={onOpenNorms}>Edytuj normy specjalne</Button>
          <Button onClick={onOpen}>Uzupełnianie minut</Button>
        </SimpleGrid>
        {table[okres?.index]?.data && (
                  <TableContainer>
                  <Table variant="striped">
                    <Thead>
                      <Tr>
                        <Th>Nick</Th>
                        <Th isNumeric>Karty</Th>
                        <Th isNumeric>Razem</Th>
                        <Th isNumeric>Obniżenie</Th>
                        <Th isNumeric>Z obniżeniem</Th>
                        <Th isNumeric>Norma</Th>
                      </Tr>
                    </Thead>
                    <Tbody>
                      <Tr>
                        <Th>Oficerowie</Th>
                      </Tr>
                      {table[okres?.index]?.data?.oficerowie?.map((option) => (
                        <Tr
                          fontWeight="bold"
                          key={option.nick == "brak" ? option.login : option.nick}
                        >
                          <Td color={"#e37b24"}>{option.nick == "brak" ? option.login : option.nick}</Td>
                          <Td
                            isNumeric
                            color={option.liczba_wyjazdow >= 20 ? "green.500" : ""}
                          >
                            {option.liczba_wyjazdow}
                          </Td>
                          <Td isNumeric>
                            <Tooltip
                              label={`Tydzień 1: ${option.liczba_minut_week1} | Tydzień 2: ${option.liczba_minut_week2}`}
                            >
                              <Text>{option.liczba_minut_total}</Text>
                            </Tooltip>
                          </Td>
                          <Td isNumeric>
                            {calculateReduction(option.liczba_wyjazdow_week2, option.roles)}
                          </Td>
                          <Td
                            isNumeric
                            color={
                              option.liczba_minut_total +
                                calculateReduction(option.liczba_wyjazdow_week2, option.roles) >=
                              getNorma(option.roles)
                                ? option.liczba_minut_total + calculateReduction(option.liczba_wyjazdow_week2, option.roles)  >=
                                    getPlus(option.roles)
                                  ? "green.500"
                                  : "blue.400"
                                : "red.700"
                            }
                          >
                            {option.liczba_minut_total +
                              calculateReduction(option.liczba_wyjazdow_week2, option.roles)}
                          </Td>
                          <Td isNumeric>{getNorma(option.roles)}/{getPlus(option.roles)}</Td>
                        </Tr>
                      ))}
                      <Tr>
                        <Th>Aspiranci</Th>
                      </Tr>
                      {table[okres?.index]?.data?.aspiranci?.map((option) => (
                        <Tr
                          fontWeight="bold"
                          key={option.nick == "brak" ? option.login : option.nick}
                        >
                          <Td color={"#c49758"}>{option.nick == "brak" ? option.login : option.nick}</Td>
                          <Td
                            isNumeric
                            color={option.liczba_wyjazdow >= 20 ? "green.500" : ""}
                          >
                            {option.liczba_wyjazdow}
                          </Td>
                          <Td isNumeric>
                            <Tooltip
                              label={`Tydzień 1: ${option.liczba_minut_week1} | Tydzień 2: ${option.liczba_minut_week2}`}
                            >
                              <Text>{option.liczba_minut_total}</Text>
                            </Tooltip>
                          </Td>
                          <Td isNumeric>
                            {calculateReduction(option.liczba_wyjazdow_week2, option.roles)}
                          </Td>
                          <Td
                            isNumeric
                            color={
                              option.liczba_minut_total +
                                calculateReduction(option.liczba_wyjazdow_week2, option.roles) >=
                                getNorma(option.roles)
                                ? option.liczba_minut_total + calculateReduction(option.liczba_wyjazdow_week2, option.roles) >=
                                    getPlus(option.roles)
                                  ? "green.500"
                                  : "blue.400"
                                : "red.700"
                            }
                          >
                            {option.liczba_minut_total +
                              calculateReduction(option.liczba_wyjazdow_week2, option.roles)}
                          </Td>
                          <Td isNumeric>{getNorma(option.roles)}/{getPlus(option.roles)}</Td>
                        </Tr>
                      ))}
                      <Tr>
                        <Th>Podoficerowie</Th>
                      </Tr>
                      {table[okres?.index]?.data?.podoficerowie?.map((option) => (
                        <Tr
                          fontWeight="bold"
                          key={option.nick == "brak" ? option.login : option.nick}
                        >
                          <Td color={"#c7320a"}>{option.nick == "brak" ? option.login : option.nick}</Td>
                          <Td
                            isNumeric
                            color={option.liczba_wyjazdow >= 20 ? "green.500" : ""}
                          >
                            {option.liczba_wyjazdow}
                          </Td>
                          <Td isNumeric>
                            <Tooltip
                              label={`Tydzień 1: ${option.liczba_minut_week1} | Tydzień 2: ${option.liczba_minut_week2}`}
                            >
                              <Text>{option.liczba_minut_total}</Text>
                            </Tooltip>
                          </Td>
                          <Td isNumeric>
                            {calculateReduction(option.liczba_wyjazdow_week2, option.roles)}
                          </Td>
                          <Td
                            isNumeric
                            color={
                              option.liczba_minut_total +
                                calculateReduction(option.liczba_wyjazdow_week2, option.roles) >=
                                getNorma(option.roles)
                                ? option.liczba_minut_total + calculateReduction(option.liczba_wyjazdow_week2, option.roles) >=
                                    getPlus(option.roles)
                                  ? "green.500"
                                  : "blue.400"
                                : "red.700"
                            }
                          >
                            {option.liczba_minut_total +
                              calculateReduction(option.liczba_wyjazdow_week2, option.roles)}
                          </Td>
                          <Td isNumeric>{getNorma(option.roles)}/{getPlus(option.roles)}</Td>
                        </Tr>
                      ))}
                      <Tr>
                        <Th>Szeregowi</Th>
                      </Tr>
                      {table[okres?.index]?.data?.szeregowi?.map((option) => (
                        <Tr
                          fontWeight="bold"
                          key={option.nick == "brak" ? option.login : option.nick}
                        >
                          <Td color={"#1cbc9d"}>{option.nick == "brak" ? option.login : option.nick}</Td>
                          <Td
                            isNumeric
                            color={option.liczba_wyjazdow >= 20 ? "green.500" : ""}
                          >
                            {option.liczba_wyjazdow}
                          </Td>
                          <Td isNumeric>
                            <Tooltip
                              label={`Tydzień 1: ${option.liczba_minut_week1} | Tydzień 2: ${option.liczba_minut_week2}`}
                            >
                              <Text>{option.liczba_minut_total}</Text>
                            </Tooltip>
                          </Td>
                          <Td isNumeric>
                            {calculateReduction(option.liczba_wyjazdow_week2, option.roles)}
                          </Td>
                          <Td
                            isNumeric
                            color={
                              option.liczba_minut_total +
                                calculateReduction(option.liczba_wyjazdow_week2, option.roles) >=
                                getNorma(option.roles)
                                ? option.liczba_minut_total + calculateReduction(option.liczba_wyjazdow_week2, option.roles)  >=
                                    getPlus(option.roles)
                                  ? "green.500"
                                  : "blue.400"
                                : "red.700"
                            }
                          >
                            {option.liczba_minut_total +
                              calculateReduction(option.liczba_wyjazdow_week2, option.roles)}
                          </Td>
                          <Td isNumeric>{getNorma(option.roles)}/{getPlus(option.roles)}</Td>
                        </Tr>
                      ))}
                      <Tr>
                        <Th>Inni</Th>
                      </Tr>
                      {table[okres?.index]?.data?.inne?.map((option) => (
                        <Tr
                          fontWeight="bold"
                          key={option.nick == "brak" ? option.login : option.nick}
                        >
                          <Td>{option.nick == "brak" ? option.login : option.nick}</Td>
                          <Td
                            isNumeric
                            color={option.liczba_wyjazdow >= 20 ? "green.500" : ""}
                          >
                            {option.liczba_wyjazdow}
                          </Td>
                          <Td isNumeric>
                            <Tooltip
                              label={`Tydzień 1: ${option.liczba_minut_week1} | Tydzień 2: ${option.liczba_minut_week2}`}
                            >
                              <Text>{option.liczba_minut_total}</Text>
                            </Tooltip>
                          </Td>
                          <Td isNumeric>
                            {calculateReduction(option.liczba_wyjazdow_week2, option.roles)}
                          </Td>
                          <Td
                            isNumeric
                            color={
                              option.liczba_minut_total +
                                calculateReduction(option.liczba_wyjazdow_week2, option.roles) >=
                                getNorma(option.roles)
                                ? option.liczba_minut_total + calculateReduction(option.liczba_wyjazdow_week2, option.roles) >=
                                    getPlus(option.roles)
                                  ? "green.500"
                                  : "blue.400"
                                : "red.700"
                            }
                          >
                            {option.liczba_minut_total +
                              calculateReduction(option.liczba_wyjazdow_week2, option.roles)}
                          </Td>
                          <Td isNumeric>{getNorma(option.roles)}/{getPlus(option.roles)}</Td>
                        </Tr>
                      ))}
                    </Tbody>
                    <Tfoot>
                      <Tr>
                        <Th>Nick</Th>
                        <Th isNumeric>Karty</Th>
                        <Th isNumeric>Razem</Th>
                        <Th isNumeric>Obniżenie</Th>
                        <Th isNumeric>Z obniżeniem</Th>
                        <Th isNumeric>Norma</Th>
                      </Tr>
                    </Tfoot>
                  </Table>
                </TableContainer>
        )}
      </Card>

      <Modal isOpen={isOpen} onClose={onClose} size="4xl">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Uzupełnij Minuty</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Flex direction={"column"} gap={5}>
              <Box>
                <Text>Dane minut dla tygodnia 1</Text>
                <Textarea
                  placeholder="Wprowadź dane minut..."
                  value={minutesText}
                  onChange={(e) => setMinutesText(e.target.value)}
                  maxH={"500px"}
                />
              </Box>
              <Box>
                <Text>Dane minut dla tygodnia 2</Text>
                <Textarea
                  placeholder="Wprowadź dane minut..."
                  value={minutesText2}
                  onChange={(e) => setMinutesText2(e.target.value)}
                  maxH={"500px"}
                />
              </Box>
            </Flex>
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="red" mr={3} onClick={handleSendMinutes} isLoading={subbmiting}>
              Akceptuj
            </Button>
            <Button onClick={onClose}>Anuluj</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
      <Modal isOpen={isOpenNorms} onClose={onCloseNorms} size="4xl">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Edycja normy specjalnej</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Flex direction={"row"} gap={5}>
              <Box>
                <Text>Norma dla wszystkich</Text>
                <Input
                  placeholder="Wprowadź..."
                  type="number"
                  value={minutesNormNormal}
                  onChange={(e) => setMinutesNormNormal(e.target.value)}
                />
              </Box>
              <Box>
                <Text>Norma dla zarządu</Text>
                <Input
                  placeholder="Wprowadź..."
                  type="number"
                  value={minutesNormManagement}
                  onChange={(e) => setMinutesNormManagement(e.target.value)}
                />
              </Box>
              <Box>
                <Text>Aktywne</Text>
                <Switch
                  isChecked={isNormActive}
                  onChange={(e) => setIsNormActive(e.target.checked)}
                />
              </Box>
            </Flex>
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="red" mr={3} onClick={handleSendNorm} isLoading={subbmitingNorm}>
              Akceptuj
            </Button>
            <Button onClick={onCloseNorms}>Anuluj</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Flex>
  );
}

export default Page;
